// ═══════════════════════════════════════════════════════════════════
//  modules/erp/PlayerAuditTab.js
//  PlayerAuditTab
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { invActionLabel, invStatusColors } from "./audit";

export function PlayerAuditTab({ uuid, token }) {
  const [rows, setRows] = useState(null);
  const load = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/players/${uuid}/inventory/actions?limit=100`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setRows(Array.isArray(data) ? data : []);
    } catch { setRows([]); }
  }, [token, uuid]);
  useEffect(() => { load(); }, [uuid, load]);

  if (!rows) return <div style={{ color: THEME.textMuted }}>Chargement…</div>;
  if (rows.length === 0) return <div style={{ color: THEME.textMuted, fontSize: 13, padding: 20, textAlign: "center" }}>Aucune action enregistrée pour ce joueur.</div>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ color: THEME.textMuted, fontSize: 12 }}>{rows.length} action(s)</div>
        <button onClick={load} style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 6, padding: "6px 12px", cursor: "pointer", fontSize: 12, fontWeight: 700 }}>🔄 Rafraîchir</button>
      </div>
      {rows.map((r) => {
        const sb = invStatusColors(r.status);
        return (
          <div key={r.id} style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                <Badge text={(r.container || "MAIN") === "ENDER" ? "Enderchest" : "Inventaire"} bg={THEME.surface} color={THEME.textMuted} />
                <span style={{ color: THEME.text, fontSize: 13, fontWeight: 600 }}>{invActionLabel(r.action)}</span>
                {r.slot != null && <span style={{ color: THEME.textMuted, fontSize: 12 }}>slot {r.slot}</span>}
                {r.amount != null && <span style={{ color: THEME.textMuted, fontSize: 12 }}>→ {r.amount}</span>}
              </div>
              <Badge text={r.status} bg={sb.bg} color={sb.col} />
            </div>
            <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 6 }}>
              par {r.requested_by || "?"} · {new Date(Number(r.created_at)).toLocaleString("fr")}
              {r.claimed_by ? ` · traité par ${r.claimed_by}` : ""}
            </div>
          </div>
        );
      })}
    </div>
  );
}
